import React from 'react';
import PropTypes from 'prop-types';

import AccessibleIcon from '../common/AccessibleIcon';
import DateString from '../common/DateString';

const propTypes = {
    folder: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
};

const defaultProps = {};

function FolderTile(props) {
    return (
        <div className="tile">
            <h3 className="tile-title" title={props.folder.name}>{props.folder.name}</h3>
            <div className="tile-info">
                <div className="tile-info-label">
                    Date created
                </div>
                <div className="tile-info-data">
                    <DateString date={props.folder.created_at}/>
                </div>
            </div>
            <div className="tile-actions">
                <button className="bare-text-button no-button-style" onClick={props.onClick}>
                    <div className="fa fa-folder fa-5x" aria-hidden="true" />
                    <div className="action-label">Open Folder</div>
                </button>
            </div>
        </div>
    );
}

FolderTile.propTypes = propTypes;
FolderTile.defaultProps = defaultProps;

export default FolderTile;
